/* MENTALLIC™ — Smart Ring · 3D hero. Auto-rotates, drag to spin. Falls back to the SVG ring without WebGL. */
// versioned URL from Liquid so a theme update is never served from a stale CDN copy
const core = await import(window.__mnrCore || './mnr-ring-core.js').catch((e) => { console.warn('[mnr] core', e); return null; });
const { hasWebGL, makeRenderer, studioEnv, buildRing } = core || {};

const canvas = document.getElementById('mnrRing3d');
const slide = canvas && canvas.closest('.mnr-gal__slide');

const fallback = () => slide && !slide.classList.contains('is-3d') && slide.classList.add('is-fallback');

async function init() {
  if (!canvas) return;
  if (!core || !hasWebGL()) return fallback();
  setTimeout(fallback, 8000);                    // very slow network: show SVG rather than an empty stage
  const THREE = await import('./mnr-three.min.js');
  const renderer = makeRenderer(THREE, canvas);
  const scene = new THREE.Scene();
  scene.environment = studioEnv(THREE, renderer);
  const key = new THREE.DirectionalLight(0xffffff, 1.4); key.position.set(-2, 3, 2); scene.add(key);

  const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 50);
  camera.position.set(0, 0, 5.9);

  const ring = buildRing(THREE);
  const spin = ring.group, liner = ring.liner;
  const tilt = new THREE.Group();
  tilt.rotation.x = 0.52; tilt.rotation.z = -0.08;
  tilt.add(spin); scene.add(tilt);

  /* sizing */
  function resize() {
    const w = canvas.clientWidth, hh = canvas.clientHeight;
    if (!w || !hh) return;
    renderer.setSize(w, hh, false);
    camera.aspect = w / hh; camera.updateProjectionMatrix();
  }
  new ResizeObserver(resize).observe(canvas); resize();

  /* interaction: horizontal drag spins, vertical scroll stays native */
  let vel = 0, dragging = false, lastX = 0, lastT = 0, idleSpeed = 0.45;
  canvas.addEventListener('pointerdown', (e) => { dragging = true; lastX = e.clientX; lastT = performance.now(); canvas.setPointerCapture(e.pointerId); });
  canvas.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    const now = performance.now(), dx = e.clientX - lastX;
    spin.rotation.y += dx * 0.012; vel = (dx * 0.012) / Math.max((now - lastT) / 1000, 0.008);
    lastX = e.clientX; lastT = now;
  });
  const end = () => { dragging = false; };
  canvas.addEventListener('pointerup', end); canvas.addEventListener('pointercancel', end);

  /* intro: fast spin that settles, then idle rotation + gentle float */
  let t0 = performance.now(); const INTRO = 1800;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let visible = true, last = t0;
  new IntersectionObserver((es) => { visible = es[0].isIntersecting; }).observe(canvas);

  function frame(now) {
    requestAnimationFrame(frame);
    if (!visible || document.hidden) { last = now; return; }
    const dt = Math.min((now - last) / 1000, 0.05); last = now;
    const p = Math.min((now - t0) / INTRO, 1), ease = 1 - Math.pow(1 - p, 3);
    if (p < 1 && !reduce) {
      spin.rotation.y = -Math.PI * 2.2 * (1 - ease) + 0.4;
      const s = 0.82 + 0.18 * ease; tilt.scale.set(s, s, s);
    } else if (!dragging) {
      vel *= Math.pow(0.04, dt);                 // inertia decay
      spin.rotation.y += (reduce ? 0 : idleSpeed * dt) + vel * dt;
    }
    tilt.position.y = reduce ? 0 : Math.sin(now / 1400) * 0.035;
    liner.emissiveIntensity = 1.3 + Math.sin(now / 380) * 0.35;
    renderer.render(scene, camera);
  }
  renderer.render(scene, camera);
  requestAnimationFrame(() => {                  // intro starts exactly when the canvas fades in
    t0 = last = performance.now();
    slide && slide.classList.remove('is-fallback');
    slide && slide.classList.add('is-3d');
    requestAnimationFrame(frame);
  });
}

/* module scripts run after HTML parse — start now, don't wait for every image (window.load) */
init().catch((e) => { console.warn('[mnr-ring-3d] fallback to SVG', e); fallback(); });
